// NewWcomment
"use client";
import React from "react";
import { Comment, Form, Label, Icon } from "semantic-ui-react";
import { ButtonItem } from "../../components";
import { styles } from "./element.js";

const NewWcomment = ({
  index,
  visibility,
  change,
  changeval,
  submit,
  value,
  form,
  buttonName,
  placeholder,
  questionId,
  userimage,
  autoFocus,
  onFocus,
  askques,
  ...props
}) => {
  return (
    <div>
      {visibility ? (
        <Comment.Group style={{ maxWidth: 600, marginLeft: 30 }} key={index}>
          <Comment>
            <Comment.Avatar
              src={
                userimage &&
                userimage !== undefined &&
                userimage !== "$context.arguments.userimage"
                  ? userimage
                  : process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/userdefault.png"
              }
            />
            <Comment.Content style={styles.content}>
              <Form
                name={form}
                onSubmit={() => submit(questionId)}
                reply
                style={{ marginTop: 0 }}
              >
                <Form.TextArea
                  {...props}
                  onChange={(e) => changeval(e)}
                  style={styles.textArea}
                  value={value}
                  rows={2}
                  placeholder={placeholder}
                  key={index}
                  autoFocus
                  onFocus={onFocus}
                />
                <Label attached="bottom" style={styles.label_ctnr}>
                  <ButtonItem
                    customclass1="reply_btn"
                    content={buttonName}
                    className="btn_blue_bg"
                    floated="right"
                  />
                </Label>
              </Form>
            </Comment.Content>
          </Comment>
        </Comment.Group>
      ) : null}
      <div style={{ clear: "both" }}></div>
    </div>
  );
};

export default NewWcomment;
